<div class="container-fluid py-3">

  <!-- Header -->
  <div class="row mb-4">
    <div class="col d-flex align-items-center">
      <div>
        <h6 class="mb-0 fw-bold">Pagos</h6>
        <small class="text-secondary">{{ data?.houseFlat?.number }} &ndash; {{ data?.houseFlat?.fullName }}</small>
      </div>
    </div>
  </div>

  <!-- Summary cards -->
  <div class="row mb-4">

    <!-- Saldo crédito -->
    <div class="col-6 col-md-3 mb-3">
      <div class="bg-white rounded-3 shadow-sm p-3 h-100">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Saldo crédito</span>
          <div class="rounded-circle d-flex align-items-center justify-content-center"
            style="height: 2.2rem; width: 2.2rem; background-color: rgba(13,202,240,0.12); flex-shrink: 0;">
            <i class="material-icons text-info" style="font-size: 1rem;">savings</i>
          </div>
        </div>
        @if(loading) {
          <div class="placeholder-glow">
            <span class="placeholder col-10 rounded bg-info" style="height: 1.8rem;"></span>
          </div>
        } @else {
          <div class="text-info fw-bold" style="font-size: calc(1rem + 0.8vh);">
            {{ data?.creditBalance | currency }}
          </div>
        }
      </div>
    </div>

    <!-- Total deuda -->
    <div class="col-6 col-md-3 mb-3">
      <div class="bg-white rounded-3 shadow-sm p-3 h-100">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Total deuda</span>
          <div class="rounded-circle d-flex align-items-center justify-content-center"
            style="height: 2.2rem; width: 2.2rem; background-color: rgba(220,53,69,0.1); flex-shrink: 0;">
            <i class="material-icons text-danger" style="font-size: 1rem;">account_balance</i>
          </div>
        </div>
        @if(loading) {
          <div class="placeholder-glow">
            <span class="placeholder col-10 rounded bg-danger" style="height: 1.8rem;"></span>
          </div>
        } @else {
          <div class="text-danger fw-bold" style="font-size: calc(1rem + 0.8vh);">
            {{ data?.totalDebt | currency }}
          </div>
        }
      </div>
    </div>

    <!-- Pagados -->
    <div class="col-6 col-md-3 mb-3">
      <div class="bg-white rounded-3 shadow-sm p-3 h-100">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Pagados</span>
          <div class="rounded-circle d-flex align-items-center justify-content-center"
            style="height: 2.2rem; width: 2.2rem; background-color: rgba(25,135,84,0.1); flex-shrink: 0;">
            <i class="material-icons text-success" style="font-size: 1rem;">check_circle</i>
          </div>
        </div>
        @if(loading) {
          <div class="placeholder-glow">
            <span class="placeholder col-10 rounded bg-success" style="height: 1.8rem;"></span>
          </div>
        } @else {
          <div class="fw-bold" style="font-size: calc(1rem + 0.8vh);">
            {{ data?.paid }}
          </div>
        }
      </div>
    </div>

    <!-- Pendientes -->
    <div class="col-6 col-md-3 mb-3">
      <div class="bg-white rounded-3 shadow-sm p-3 h-100">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <span class="text-secondary fw-500" style="font-size: calc(0.65rem + 0.55vh);">Pendientes</span>
          <div class="rounded-circle d-flex align-items-center justify-content-center"
            style="height: 2.2rem; width: 2.2rem; background-color: rgba(255,193,7,0.12); flex-shrink: 0;">
            <i class="material-icons text-warning" style="font-size: 1rem;">pending</i>
          </div>
        </div>
        @if(loading) {
          <div class="placeholder-glow">
            <span class="placeholder col-10 rounded bg-warning" style="height: 1.8rem;"></span>
          </div>
        } @else {
          <div class="fw-bold" style="font-size: calc(1rem + 0.8vh);">
            {{ data?.pending }}
          </div>
        }
      </div>
    </div>

  </div>

  <!-- Tabs -->
  <div class="row">
    <div class="col-12">
      <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-pills mb-3">
        <li [ngbNavItem]="1">
          <button ngbNavLink>Historial de pagos</button>
          <ng-template ngbNavContent>
            <app-house-flat-payment-history-page
              [payments]="data?.payments ?? []"
              [loading]="loading">
            </app-house-flat-payment-history-page>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <button ngbNavLink>Historial de crédito</button>
          <ng-template ngbNavContent>
            <app-house-flat-credit-history-page
              [creditTransactions]="data?.creditTransactions ?? []"
              [creditBalance]="data?.creditBalance ?? 0"
              [loading]="loading"
              [neighborhoodId]="neighborhoodId"
              [streetBuildingId]="streetBuildingId"
              [houseFlatId]="houseFlatId"
              (refresh)="loadData()">
            </app-house-flat-credit-history-page>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
    </div>
  </div>

</div>
